module.exports = __webpack_public_path__ + "img/login-bgx.ad5eb257.png";